import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';
import { ONE_HOUR } from './time-frames';

export const InPastHourMatcher: FieldMatcher = {
  name: 'inPastHour',
  displayName: 'Within last hour',
  options: {
    setValue: (): string => Date.now().toString(),
    chipFormatter: (value: string): string =>
      `since ${new Intl.DateTimeFormat('en-US', { timeStyle: 'short' }).format(new Date(Number(value) - ONE_HOUR))}`,
  },
};